import React from 'react'
import { createContext, useState, useRef, useCallback } from "react";
import axios from "axios"
import AuthContext from "./AuthContext";
import StatusContext from "./StatusContext";
import ClientContext from "./ClientContext";

import { config } from '../config';

const StocksContext = createContext();

export default StocksContext;

export const StocksProvider = ((props) => {
    const promptareaRef = useRef(null)
    const [templateName, setTemplateName] = useState('');
    const [chatNames, setChatNames] = useState([])
    const [chatName, setChatName] = useState('');
    const [templates, setTemplates] = useState([]);
   
    const [prompts, setPrompts] = useState([]);
    const [prompt, setPrompt] = useState('')
    const [promptedit, setPromptEdit] = useState(false)
    const [samples, setSamples] = useState([])
    const [status, setStatus] = useState();

    const [promptsAvailable, setPromptsAvailable] = useState(false);
    

    const[allresponses, setAllResponses] = useState([])
    const[newPrompt, setNewPrompt] = useState({
        id: 0,
        who: '',
        what: '',
    })

    const[showNewPromptDialog, setShowNewPromptDialog] = useState(false)
    const [editmode, setEditMode] = useState(false)

    const[preview, setPreview] = useState("")
    const[showPreviewDialog, setShowPreviewDialog] = useState(false)
    const[chatPrompt, setChatPrompt] = useState('')

    const[arrowLeft, setArrowLeft] = useState(false)
    const[arrowRight, setArrowRight] = useState(false)
    const[arrowSplit, setArrowSplit] = useState(true)

    const [stockPrices, setStockPrices] = useState([])
    const [stockSymbols, setStockSymbols] = useState([])
    

    const [showSymbolsDialog, setShowSymbolsDialog] = useState(false)

    const [showHistoricalPrices, setShowHistoricalPrices] = useState(false)
    const [historicalDataLength, setHistoricalDataLength] = useState('2') //10 days

    const [showProgressDialog, setShowProgressDialog] = useState(false)
    const [openDialogPrices, setDisplayDialogPrices] = useState(false);
    const [openDialogAnalyze, setDisplayDialogAnalyze] = useState(false)
    const [openDialogFastAnalyze, setDisplayDialogFastAnalyze] = useState(false)
    const [showRules, setShowRules] = useState(true)

    const [newstockSymbols, setNewStockSymbols] = useState([
        [],
    ])
    
    const [selectedSymbolsIndex, setSelectedSymbolsIndex] = useState(0)
    const [openDialogDeleteSymbolsGroup, setDisplayDialogDeleteSymbolsGroup] = useState(false)
    const [addSymbolsGroup, setAddSymbolsGroup] = useState(false)
    const [reversedStockPrices, setReversedStockPrices] = useState([])
     
    
    const {
        currentUser, 
        checkCurrentUser,
        checkServerCode,
    } = React.useContext(AuthContext);

    const {
        setStatusNavbar,
        sortTemplates,
        changeLanguage,
        setIsLoading,
        handleFocus,
        getAIProvider,
        getAIModel,
        getAIName,
        setWaitOnResponse,
    } = React.useContext(StatusContext);


    const {
       availablecredits,
       updateCredits
    } = React.useContext(ClientContext);

    let allsymbols = []
    const textsymbolchartlink = "Highlite stocks recomended for buy. Make each symbol in a table a clickable link using 'https://www.google.com/search?q=<symbol>+stock+price+chart' as a link."

    
    const handleFastAnalysis = () => {

        console.log("handleFastAnalysis")
        
        
         if (stockSymbols.length === 0)
        {
            console.log("No stocks")
            setStatus("There are no symbols. Please, add symbols.")
            return
        }

        if (stockPrices.length > 0)
        {
            setDisplayDialogFastAnalyze(true)
            return
        }

        onFastAnalysis(true)
    

    }

     const onFastAnalysis = async (fetchprices) => {

        setStatus('')
        if ( availablecredits <= 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }

        setWaitOnResponse("Getting historical data...")
        handleFocus()
        //Scroll and focus is messed up with this dialog???
        //setShowProgressDialog(true)
    
        if (fetchprices)
        {
            //get stock prices
            try {
                await getPrices()
            }
            catch (err) {
                setIsLoading(false);
                setShowProgressDialog(false)
                return
            }

            if (allsymbols.length === 0)
            {
                setStatus("Historical data are missing.")
                setIsLoading(false);
                setShowProgressDialog(false)
                return
            }
        }
        else
        {
            console.log("FA no fetch prices")
            allsymbols = [...stockPrices]
        }

        setWaitOnResponse("Analyzing data...")

        let allprices = []

       
        for ( let i = 0; i < allsymbols.length; ++i)
        {
              
                 let prices = []
                //Days are in decending order. The most recent is the first.
              
                for (let j = 0; j < allsymbols[i].prices.length; ++j)
                {
                    let b = {}
                    b.day = allsymbols[i].prices[j].id
                    b.timestamp = allsymbols[i].prices[j].timestamp
                    b.symbol =  allsymbols[i].prices[j].symbol
                    b.price = allsymbols[i].prices[j].close
                    b.volume = allsymbols[i].prices[j].volume
                    prices.push(b)
                   
                }

                let a = {}
                a.symbol =  allsymbols[i].symbol
                a.prices = prices

                allprices.push(a)

        }

   
    
        //TASK:
        //Apply the following Conditions to symbols historical data. If any Condition is satisfied then recommwnd stock to buy. 
        //Note: Calculate last day gain as a gain in Day 10 .

        //CONDITION 1:.
        //Rule 1: Day 10 price must be higher then Day 9 price by more then 4%..
        //Rule 2: Gain from Day 7 through Day 9 must be less then 5%.

        //CONDITION 2:
        // Rule 3: Day 10 price must be lower then greater price of Day 8 and Day 9 price by more then 5%.
        //Rule 4: Day 8 price must be higher then Day 1 price.

        //RESULT:
        //Return results in a table form for all stocks. Highlite stocks recomended for buy.
        //tock: Buy: Rule 1: Rule 2: Rule 3: Rule 4: Condition 1: Condition 2: Gain in first 8 days: % Gain in last 2 days: % Last day gain:%


     
        let prompt = ''
        for ( let i = 0; i < allprices.length; ++i)
        {

            let buy_stock = false
            let rule_1 = false
            let rule_2 = false
            let rule_3 = false
            let rule_4 = false

            let prices = allprices[i].prices

            let Day1 = prices[0].price
            let Day7 = prices[6].price
            let Day8 = prices[7].price
            let Day9 = prices[8].price
            let Day10 = prices[9].price

            /*
            console.log("Symbol:", allprices[i].symbol)
            console.log("=======")
            console.log("Day 1:", Day1)
            console.log("Day 7:", Day7)
            console.log("Day 8:", Day8)
            console.log("Day 9:", Day9)
            console.log("Day 10:", Day10)
            */

            let a = ((Day10 - Day9) / Day9) * 100
            //console.log("Rule 1:", a)

            //Rule 1
            if ( a > 4)
                rule_1 = true

            //Rule 2
            a = ((Day9 - Day7) / Day7) * 100
            //console.log("Rule 2:", a)

            if ( a < 5 )
                rule_2 = true

            //Rule 3
            let a_max = Math.max(Day8, Day9)
            a = ((Day10 - a_max) / Day10) * 100
            /*
            console.log("Rule 3:", a)
            console.log("a-max:", a_max)
            console.log("Day 10:", Day10)
            */

            if ( a > 5 )
                rule_3 = true

            //Rule 4
            if ( Day8 > Day1)
                rule_4 = true

            let condition_1 = (rule_1 && rule_2) ? true : false
            let condition_2 = (rule_3 && rule_4) ? true : false

            if (condition_1 || condition_2)
                buy_stock = true

            //other calculations
            let gain_in_first_8_days = ((Day8 - Day1) / Day1) * 100
            let gain_in_last_2_days =  ((Day10 - Day8) / Day8) * 100
            let last_day_gain = ((Day10 - Day9) / Day9) * 100

       

            prompt += "Symbol: " + allsymbols[i].prices[0].symbol
            prompt += "\n===================="
            prompt += "\nBUY:" + buy_stock
            prompt += "\nRule 1:" + rule_1
            prompt += "\nRule 2:" + rule_2
            prompt += "\nRule 3:" + rule_3
            prompt += "\nRule 4:" + rule_4
            prompt += "\nCondition 1:" + condition_1
            prompt += "\nCondition 2:" + condition_2

            prompt += "\nGainInFirst8Days:" + gain_in_first_8_days.toFixed(2)
            prompt += "\nGainInLast2Days:" + gain_in_last_2_days.toFixed(2)
            prompt += "\nLastDayGain:" + last_day_gain.toFixed(2)

            prompt += '\n'

        }

       
        setIsLoading(true)

        //let query = "Return results in a table form for all stocks." + prompt
        let query = textsymbolchartlink + prompt

       // console.log("Query:",query)
       
        let req = {
            request: query,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

         try {
            
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })

            let server_response = JSON.parse(res.data);

            let i = 0
            if (allresponses.length)
            {
                i = allresponses[allresponses.length-1].id + 1
            }
            let r = {
                id:  i,
                delete: false,
                prompt: "Response:",
                response: server_response.data,
                aiprovider: getAIProvider(),
                aimodel: getAIModel(),
                ainame: getAIName(),
            }

            setAllResponses([...allresponses, r])
           
            if (arrowLeft)
                setArrowSplit(true)
            
            updateCredits(server_response.tokens)

        } catch (err) {
            console.log("Error:", err)
            setStatus(`Error: ${checkServerCode(err.response.data)}`)
        }

        setWaitOnResponse('')  
        setShowProgressDialog(false)
        setIsLoading(false)
    }


    const onLoadSymbols = useCallback (async () => {

        setIsLoading(true)
        
        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/stocks/loadsymbols", { currentUser })

            
            if (res.data.length > 0)
            {
                let symbols = JSON.parse(res.data[0].symbols)
                if (symbols.length > 0) 
                {
                    setNewStockSymbols(symbols)
                    setSelectedSymbolsIndex(0)
                    setStockSymbols(symbols[0])
                }
            }
            else
            {
                  // Handle case when res.data is empty
                console.log("No data in res.data")

            }
            
        }
        catch (err) {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
        }
        setIsLoading(false)

    }, [checkServerCode, currentUser, setIsLoading])

     const onSaveSymbols = async (stocksymbols) => {

        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (stocksymbols.length === 0) {
            setStatusNavbar('There are no stocks symbols to save.')
            return
        }

        setIsLoading(true);

        let symbols = JSON.stringify(stocksymbols)

        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/stocks/savesymbols", { currentUser, symbols }, {
                withCredentials: true
            })

        }
        catch (err) {
            setStatusNavbar(`Error: ${checkServerCode(err.code)}`)
          
        }
            
        setIsLoading(false)
        
    }


    
    const handleDeleteSymbolsGroup = (index) => {
        if (newstockSymbols[index].length > 0){
            setSelectedSymbolsIndex(index)
            setDisplayDialogDeleteSymbolsGroup(true)
        }
        else
        {
            const a = newstockSymbols.filter((_, i) => i !== index);
            setNewStockSymbols([...a])
        }
    }

    const handleSelectSynbols = (index) => {
        //clear prices
        setStockPrices([])
        setSelectedSymbolsIndex(index)
        setStockSymbols(newstockSymbols[index])
    }

    const onAddNewSymbols = (index) => {
        setSelectedSymbolsIndex(index)

        setStockSymbols(newstockSymbols[index])
        
        setStatus('')
        setShowSymbolsDialog(true)
    }

    const onAnalyze = () => {
        /*
        if (stockSymbols.length === 0)
        {
            console.log("No stocks")
            setStatus("There are no symbols. Please, add symbols.")
            return
        }
        */

        if (stockPrices.length > 0)
        {
            setDisplayDialogAnalyze(true)
            return
        }

        onSubmit(true)

    }

    const closeDialogBoxPrices = () => {
        setDisplayDialogPrices(false);
     };
  
     const openDialogBoxPrices = () => {
        setDisplayDialogPrices(true);
     };

     const closeDialogBoxAnalyze = () => {

        setDisplayDialogAnalyze(false);
     };
  
     const openDialogBoxAnalyze = () => {
        setDisplayDialogAnalyze(true);
     };

     const openDialogBoxFastAnalyze = () => {
        setDisplayDialogFastAnalyze(true);
     };

      const closeDialogBoxFastAnalyze = () => {

        setDisplayDialogFastAnalyze(false);
     };

     const closeDialogBoxDeleteSymbolsGroup = (index) => {
        //remove symbols group

        setDisplayDialogDeleteSymbolsGroup(false);
     };
  
     const deleteSymbolsGroup = () => {
        setDisplayDialogDeleteSymbolsGroup(false);
   
         const a = newstockSymbols.filter((_, i) => i !== selectedSymbolsIndex);
        setNewStockSymbols([...a])
        setSelectedSymbolsIndex(0)
     }



    const displayExample1 = () => {
      
        let strategy = {
                id: 0,
                //symbols: symbols,
                name: "Buy - dip 5% 10days",
                historicaldata: 2,
                prompts: [
                            {
                                id: 1,
                                who:"TASK:",
                                what:'Apply the following Condition to symbols historical data.If Condition is satisfied then recommend stock to buy.Note: Calculate last day gain as a gain in Day 10 .',
                            },
                        
                            {
                                id: 2,
                                who:"CONDITION:",
                                what:`Recommend buying the stock if it showed an upward trend during the first 8 days of trading and then declined by more than 5% in the last two trading days.`
                            },
                        
                            {
                                id: 3,
                                who:"RESULT:",
                                what:`Return results in a table form for all stocks. \nStock:\nBuy:\nCondition:\nGain in first 8 days: %\nGain in last 2 days: %\nLast day gain:%`
                            },
                            
                          
                        ],
                response: [],
            };

        displayTemplate(strategy)
    }

     const displayExample2= () => {
        let strategy = {
            id: 0,
            //symbols: symbols,
            name: "Buy - up 5% 10days",
            historicaldata: 1,
            prompts: [
                    {
                        id: 1,
                        who:"TASK:",
                        what:`Calculate stock  gain in last 2 trading days. Start with Day 9.\nCalculate stock gain from Day 1 though Day 8.`
                    },
                    {
                        id: 2,
                        who:"RULES:",
                        what:`Rule 1: Day 10 price must be higher then Day 9 price by more then 5%..\nRule 2: Gain from Day 1 through Day 8 must be less then 5%.\n\nIf BOTH RULES ARE SATISFIED STOCK SHOULD BE RECOMENDED FOR BUY.`
                    },
                       {
                        id: 3,
                        who:"RESULT:",
                        what:`Return results in a table form for all stocks. : \nStock:\nBuy:\nRule 1:\nRule 2:\nGain in first 8 days: %\nGain in 2 days: %`
                    },
                ],
            response: [],
            };

        displayTemplate(strategy)
    }

     const displayExample3 = () => {
      
        let strategy = {
                id: 0,
                //symbols: symbols,
                name: "Analyze stocks",
                historicaldata: 2,
                prompts: [
                            {
                                id: 1,
                                who:"TASK:",
                                what:'Analyze prices for given stocks and give recommendation for buy.',
                            },
                       
                            {
                                id: 2,
                                who:"RESULT:",
                                what:"Return results in a table form for all stocks."
                            },
                            
                          
                        ],
                response: [],
            };

        displayTemplate(strategy)
    }


    const getPrices = async () => {

        let totalcredits = 0

         if (stockSymbols.length === 0)
        {
            setStatus("There are no symbols. Please, add symbols.")
            return
        }

        setStatus('')
        setIsLoading(true)
        const symbols = [...stockSymbols]

        let days = 10
        if ( historicalDataLength === '1')
            days = 5
        else if ( historicalDataLength === '2')
            days = 10
        else if ( historicalDataLength === '3')
            days = 15
        else if ( historicalDataLength === '4')
            days =30
    
         try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/stocks/getprices", {currentUser, symbols, days}) 
            //console.log("getPrices - data", res.data)
        
            if ( res.data !== null)
            {

                for ( let i = 0; i < res.data.length; ++i)
                {
                    
                    if (res.data[i].data.success === false)
                    {
                        setStatus(`Symbol ${res.data[i].symbol} ${res.data[i].data.message}`)
                        continue
                    }
            
                    let prices = []
                    
                 
                    for ( let j = 0; j < res.data[i].data.body.length; ++j)
                    {
                        let b = res.data[i].data.body
                        let t = {}
                        t.id = j+1
                        t.symbol = res.data[i].symbol
                        t.timestamp = b[j].timestamp
                        t.close = b[j].close
                        //t.high = b[j].high
                        //t.low = b[j].low
                        //t.open = b[j].open
                        t.volume = b[j].volume
                        prices.push(t)
                       
                    }
                  
                    let a = {
                        symbol: res.data[i].symbol,
                        prices : prices
                    }
                    
                    allsymbols.push(a)
                    
                    //Take 25 credits for each symbol price request
                    totalcredits += 25
                }


                setStockPrices([...allsymbols])
             
             // Create a deep copy to avoid mutating the original
                let reversedprices = allsymbols.map(symbol => ({
                    ...symbol,
                    prices: [...symbol.prices].reverse()  // Create a new reversed array
                }));

                console.log("Reversed Prices:", reversedprices)
                setReversedStockPrices(reversedprices)
              
                updateCredits(totalcredits)
            
            }
        }
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }

        setIsLoading(false)
        return

    }

    const onEditMode = (prompt) =>
        {
         console.log("oneditMode:", prompt)
         setEditMode(true)
         setNewPrompt(prompt)
         setShowNewPromptDialog(true)
        }

    const onAcceptDeleteResponse = (response) => {
        let a = allresponses.filter(item => item.id !== response.id)

        for ( let i = 0; i < a.length; ++i)
            a[i].id = i

        setAllResponses(a)
      
      }
      
      const onCancelDeleteResponse = (response) => {
        let a = [...allresponses]

        for ( let i = 0; i < a.length; i++)
        {
            if ( a[i].id === response.id)
            {
                a[i].delete = false;
                break
            }
        }
      
        setAllResponses(a)
      }
      
      const onDeleteResponse = (response) => {
    
        let a = [...allresponses]
 
        for ( let i = 0; i < a.length; i++)
        {
            if ( a[i].id === response.id)
            {
                a[i].delete = true;
                break
            }
        }
       
        setAllResponses(a)
      }


const  ScrollToBottom = () => {

    
    setTimeout(() => {
        if (promptareaRef.current) {
            const { offsetHeight, scrollHeight } = promptareaRef.current;
            const bottomPosition = (scrollHeight - offsetHeight)*2;
            promptareaRef.current.scrollTo({ top: bottomPosition, behavior: 'smooth' });
          }
        
      }, 100);

    }

    const onClearResponse = () => {
        console.log("onClearResponse")
        setAllResponses([])
        setPrompt('')
    }

    const onClearPrompts = () => {
        //console.log("onClearPrompts")
        setPrompt('')
        setPrompts([])
        setTemplateName('')
        setPromptsAvailable(false)
      
        setShowHistoricalPrices(false)
        setStatus('')
       
    }

    const adjustTemplates = (filteredTemplates) => {
        let adjustedTemplates = []
        let i = 0;
        filteredTemplates.forEach((templ) => {
           let newtempl = templ;
           newtempl.id = i;
           adjustedTemplates.push(newtempl);
           i++
        })

        return adjustedTemplates;
    }


    const deleteTemplate = async (deletionTemplate) => {
        console.log("Delete Template")
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        let newTemplates = [];

        setIsLoading(true)

        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/stocks/get", {currentUser}) 
            newTemplates =JSON.parse(res.data[0].templates)  
        }
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }

        let filteredTemplates = newTemplates.filter(template => template.id !== deletionTemplate.id)
        //adjust array indexes
        let adjustedTemplates = adjustTemplates(filteredTemplates)
  
        var customtemplates = JSON.stringify(adjustedTemplates)
        
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/stocks/save", { currentUser, customtemplates }, {
                withCredentials: true
            })
            setTemplates(adjustedTemplates);
        }
        catch (err) {
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }

        //if (templateName === deletionTemplate.name) {
        //    onClearResponse()
        //}

        setIsLoading(false)
       
    }

    const displayTemplate = (displayedChat) => {
     
        console.log("displayTemplate")
        onClearPrompts();
        if (displayedChat.response)
         setAllResponses([...displayedChat.response])
        else
         setAllResponses([])

        setPrompts(displayedChat.prompts)
        setTemplateName(displayedChat.name)
    
        setHistoricalDataLength(displayedChat.historicaldata)
    
        setPromptsAvailable(true);
        setArrowSplit(true)

        //mobile display oonly
        setShowRules(true)              
      
    }

    //Preview
    const onPreview = () => {
        setPreview(formatPrompt())
        setShowPreviewDialog(true)
    }

    const onSave = async () => {
       
        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (templateName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'namenotdefined'))
            return
        }

        let newTemplates = [];
        let customtemplates = [];

        setIsLoading(true);

        let q = "/deda_ai_api/stocks/get"
        try {
            const res = await axios.post(config.url.API_URL + q, {currentUser}) 

            if (res.data.length > 0) {
                //Templates already exists
             
                let templates = JSON.parse(res.data[0].templates)
                console.log('Templates exists:', templates)

                //when all templates are deleted array saved in DB is empty. Check for that case.
                if (templates.length === 0)
                {
                    let newTemplate = {
                        id: 0,
                        //symbols: stockSymbols,
                        historicaldata: historicalDataLength,
                        name: templateName,
                        prompts: prompts,
                        response: allresponses,
                    };

                    newTemplates.push(newTemplate)
                    customtemplates = JSON.stringify(newTemplates)
                    console.log("CustomTemplates 1:", customtemplates)

                }
                else
                {
                    newTemplates = JSON.parse(res.data[0].templates)

                    const template = newTemplates.find(p => p.name === templateName);
                    if ( template)
                    {
                        //Update
                        let result = window.confirm(changeLanguage('tutor', 'sametopic'));
                        if (!result)
                        {
                            setIsLoading(false);
                            return;
                        }

                        //template.symbols = stockSymbols;
                        template.historicaldata = historicalDataLength;
                        template.prompts = prompts;
                        template.response = allresponses;
                        customtemplates = JSON.stringify(newTemplates)
                    }
                    else
                    {
                        //Add
                        let newTemplate = {
                            id: newTemplates.length,
                            //symbols: stockSymbols,
                            historicaldata: historicalDataLength,
                            name: templateName,
                            prompts: prompts,
                            response: allresponses,
                        };
                        newTemplates.push(newTemplate)
                        let sortedTemplates = sortTemplates(newTemplates)
                        let adjustedTemplates = adjustTemplates(sortedTemplates)
                        customtemplates = JSON.stringify(adjustedTemplates)
                        newTemplates = [...adjustedTemplates]
                    }
                }
            }
            else
            {
                // Handle case when res.data is empty
                //New user does not have any data and there are no saved templates.
                
                    let newTemplate = {
                        id: 0,
                        //symbols: stockSymbols,
                        historicaldata: historicalDataLength,
                        name: templateName,
                        prompts: prompts,
                        response: allresponses,
                 };
                newTemplates.push(newTemplate);
             
                customtemplates = JSON.stringify(newTemplates)
                
            }

            try {
                const res = await axios.post(config.url.API_URL + "/deda_ai_api/stocks/save", { currentUser, customtemplates }, {
                withCredentials: true
                })

                setTemplates(newTemplates)
                setIsLoading(false);
                return res;
            }
            catch (err) {
                setStatusNavbar(`Error: ${checkServerCode(err.code)}`)
                setIsLoading(false);
                return
            }
            
        } catch (err) {
            console.log("Received error 1:", err)
            setStatusNavbar(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false);
        }
        
        setIsLoading(false)
        
    }

    const formatPrompt = () => {
        let req = ''
        const regex = /^(?!.*[.;:?!]$).*$/;
        for (let i = 0; i < prompts.length; i++) {
            let who = prompts[i].who
            let what = prompts[i].what
            who.trim()
            what.trim()

            if (who.length && regex.test(who)) {
                who += ":"
            }
            if (what.length && regex.test(what)) {
                what += "."
            }
            req += who + '\n\n' + what + '\n\n';
            

        }

        //req += 'Please provide an answer from the above context to the following query: ' + chatPrompt
        req += chatPrompt

        return req;


    }
    const onSubmit = (fetchprices) => {

        if (prompts.length === 0)
        {
            setStatus("There is no strategy. Please, add a strategy.")
            return
        }
     
        if (stockSymbols.length === 0)
        {
            setStatus("The list contains no symbols. Please add one or more.")
            return
        }

        let req = formatPrompt()

        if (req.length === 0) {
            return
        }

        SendRequest(req, fetchprices)
    }

  
    const SendRequest = async (request, fetchprices) => {
        setStatus('')
        if ( availablecredits <= 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }

        setWaitOnResponse("Getting historical data...")
        handleFocus()
        //setShowProgressDialog(true)
        setIsLoading(true);
    
        if (fetchprices)
        {
            allsymbols = []
            //get stock prices
            try {
                await getPrices()
            }
            catch (err) {
                setIsLoading(false);
                setShowProgressDialog(false)
                return
            }

            if (allsymbols.length === 0)
            {
                setStatus("Historical data are missing.")
                setIsLoading(false);
                setShowProgressDialog(false)
                return
            }
        }
        else
        {
            allsymbols = [...stockPrices]
        }

        //We need to prepare prices. Replace timestamp with day1, day2, etc
        //Set prices so that the earliest price is first.


        let allprices = []
       
        let textprices = 'Prices are: '

        for ( let i = 0; i < allsymbols.length; ++i)
        {
              
                 let prices = []
              
                for (let j = 0; j < allsymbols[i].prices.length; ++j)
                {
                    let b = {}
                    b.day = allsymbols[i].prices[j].id
                    //b.timestamp = allsymbols[i].prices[j].timestamp
                    //b.symbol =  allsymbols[i].prices[j].symbol
                    b.price = allsymbols[i].prices[j].close
                    b.volume = allsymbols[i].prices[j].volume
                    prices.push(b)
                   
                }

                let a = {}
                a.symbol =  allsymbols[i].symbol
                a.prices = prices

                allprices.push(a)
        }

       
        for ( let i = 0; i < allprices.length; ++i)
        {
            let s = ''
            s = "Symbol:" + allprices[i].symbol + '\n'
            s += "=============\n"

            let t = ''
            for ( let j = 0; j < allprices[i].prices.length; ++j)
            {
                t = `Day ${allprices[i].prices[j].day}: price: ${allprices[i].prices[j].price} volume: ${allprices[i].prices[j].volume}`
                s += t + '\n'
            }

            textprices += s
        }

        let query = request + textsymbolchartlink + "\n" + textprices
        //console.log("SendREquest - query:", query)
        //Reverse back prices
        /*
        for ( let i = 0; i < allsymbols.length; ++i)
        {
            allsymbols[i].prices.reverse()
        }
        */
        let req = {
            request: query,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }
    
        setWaitOnResponse("Analyzing data...")
        setIsLoading(true);

        try {
            
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })

            let server_response = JSON.parse(res.data);

            let i = 0
            if (allresponses.length)
            {
                i = allresponses[allresponses.length-1].id + 1
            }
            let r = {
                id:  i,
                delete: false,
                prompt: "Response:",
                response: server_response.data,
                aiprovider: getAIProvider(),
                aimodel: getAIModel(),
                ainame: getAIName(),
            }

            setAllResponses([...allresponses, r])
           
            setPrompt('')
            
            if (arrowLeft)
                setArrowSplit(true)
            
            updateCredits(server_response.tokens)

        } catch (err) {
            console.log("Error:", err)
            setStatus(`Error: ${checkServerCode(err.response.data)}`)
        }

        setWaitOnResponse('')  
        setShowProgressDialog(false)
        setShowHistoricalPrices(false)
        setIsLoading(false)
    }

    //Add Prompt
    const addPrompt = (prompt) => {
        var id = 1;
        if (prompts.length > 0) {
            id = prompts[prompts.length - 1].id + 1;
           
        }

        prompt.id = id
        setPrompts([...prompts, prompt])
        setPromptsAvailable(true);
        ScrollToBottom();

    }

    const updatePrompt = (prompt) => {
        const newPrompts = [...prompts]
        newPrompts[prompt.id-1] = prompt

        setPrompts(newPrompts)
        setPromptsAvailable(true);
    }

    //Delete prompt
    const deletePrompt = (id, e) => {
        //check for last prompt.
        //we cannot check for 0 because of rendering
        if (prompts.length === 1)
            setPromptsAvailable(false);

        let newprompts = prompts.filter((prompt) => prompt.id !== id)
        newprompts = [...prompts]
        newprompts = newprompts.filter((prompt) => prompt.id !== id)
    
        //adjust ids
        if (newprompts.length > 1)
        {
            for (let i = 1; i <= newprompts.length; i++)
            {
                newprompts[i-1].id = i;
            }
        }

        setPrompts([...newprompts])
    }

    //Change who
    const changeWho = (id, e) => {
        var s = e.target.value;
        e.target.style.height = 'auto';
        e.target.style.height = `${e.target.scrollHeight}px`;
        const newPrompts = prompts.map(prompt => {
            if (prompt.id === id) {
                return { ...prompt, who: s }
            }
            return prompt
        })

        setPrompts(newPrompts)
    }

       
    //Change prompt
    const changePrompt = (id, e) => {
        var s = e.target.value;
        e.target.style.height = 'auto';
        e.target.style.height = `${e.target.scrollHeight}px`;
        const newPrompts = prompts.map(prompt => {
            if (prompt.id === id) {
                return { ...prompt, what: s }
            }
            return prompt
        })

        setPrompts(newPrompts)

       
    }

    const onClickedPrompt = () => {
        console.log("onClickedPrompt")
       
    }

    //Move prompt
    const moveupPrompt = (id, e) => {
        console.log('moveupPrompt:', id)

        var index = prompts.findIndex((obj => obj.id === id))
        console.log("index: ", index)

        if (index > 0) {
            const newprompts = [...prompts]

            newprompts.splice(index - 1, 0, newprompts.splice(index, 1).pop());
         
           //adjust ids
            if (newprompts.length > 1)
            {
                for (let i = 1; i <= newprompts.length; i++)
                {
                    newprompts[i-1].id = i;
                }
            }
        
            
            setPrompts([...newprompts])
        }
    }

    //Move dowwn
    const movedownPrompt = (id, e) => {

        var index = prompts.findIndex((obj => obj.id === id))
        if (index < prompts.length - 1) {
            const newprompts = [...prompts]
            newprompts.splice(index + 1, 0, newprompts.splice(index, 1).pop());
            //adjust ids
            if (newprompts.length > 1)
            {
                for (let i = 1; i <= newprompts.length; i++)
                {
                    newprompts[i-1].id = i;
                }
            }
            setPrompts(newprompts)
        }
    }

    //edit prompt
    const editPrompt = (id, e) => {
        console.log("editPrompt: ", id)
        setPromptEdit(!promptedit)
        return;
    }

    const getTemplates = async () => {

        let sortedTemplates  = []
        setIsLoading(true)
        
        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/stocks/get", { currentUser })

            if (res.data.length > 0)
            {
                let templates = JSON.parse(res.data[0].templates)
                if (templates != null) {
                    sortedTemplates = sortTemplates(templates)
                    setTemplates(sortedTemplates)
                }
            }
            else
            {
                  // Handle case when res.data is empty
                console.log("No data in res.data")

            }
        }
        catch (err) {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
        }
        setIsLoading(false)

        let chatsstatus = {chats: sortedTemplates, status: 200}

        return chatsstatus

    }

    return <StocksContext.Provider value={{
        onClearResponse,
        chatNames,
        setChatNames,
        chatName,
        setChatName,
        onSave,
        displayTemplate,
        deleteTemplate,
        templates,
        setTemplates,
        templateName,
        setTemplateName,
        onClearPrompts,
        samples,
        setSamples,
        onSubmit,
        onPreview,
        
        addPrompt,
        deletePrompt,
        changePrompt,
        moveupPrompt,
        movedownPrompt,
        prompts,
        setPrompts,
        prompt,
        setPrompt,
        editPrompt,
        promptedit,
        
        status,
        getTemplates,
        
        setPromptsAvailable,
        promptsAvailable,
        onClickedPrompt,

       
        promptareaRef,
        allresponses,
        onAcceptDeleteResponse,
        onCancelDeleteResponse,
        onDeleteResponse,
        changeWho,
        newPrompt,
        setNewPrompt,
        showNewPromptDialog,
        setShowNewPromptDialog,

        editmode,
        setEditMode,
        onEditMode,
        updatePrompt,

        preview, 
        showPreviewDialog, 
        setShowPreviewDialog,

        chatPrompt, 
        setChatPrompt,

        arrowLeft, 
        setArrowLeft,
        arrowRight,
        setArrowRight,
        arrowSplit,
        setArrowSplit,

        getPrices,
        stockPrices,
        stockSymbols,
        setStockSymbols,
        showSymbolsDialog,
        setShowSymbolsDialog,

        showHistoricalPrices,
        setShowHistoricalPrices,

        setStatus,
        historicalDataLength,
        setHistoricalDataLength,

        showProgressDialog,

        displayExample1,
        displayExample2,
        displayExample3,

        openDialogBoxPrices,
        closeDialogBoxPrices,
        openDialogPrices,

        openDialogBoxAnalyze,
        closeDialogBoxAnalyze,
        openDialogAnalyze,

        openDialogBoxFastAnalyze,
        closeDialogBoxFastAnalyze,
        openDialogFastAnalyze,

        onAnalyze,

        onAddNewSymbols,
        newstockSymbols,
        setNewStockSymbols,
        selectedSymbolsIndex,
        handleSelectSynbols,
        handleDeleteSymbolsGroup,

        closeDialogBoxDeleteSymbolsGroup,
        openDialogDeleteSymbolsGroup,

        deleteSymbolsGroup,

        onLoadSymbols,
        onSaveSymbols,

        showRules,
        setShowRules,

        setSelectedSymbolsIndex,
        handleFastAnalysis,

        onFastAnalysis,

        addSymbolsGroup,
        setAddSymbolsGroup,

        reversedStockPrices
    }}>
        {props.children}
    </StocksContext.Provider>
})